import {render} from "react-dom";
import React from 'react';
import AgendamentoPage from "../pages/AgendamentoPage";


render(<AgendamentoPage />)